import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242526",
      d: "M6.179 11.94a.61.61 0 0 1-.47-.19L2.611 8.652a.52.52 0 0 1-.156-.397.56.56 0 0 1 .167-.397.53.53 0 0 1 .391-.161q.23 0 .391.161l2.775 2.775L12.59 4.22a.54.54 0 0 1 .397-.16.54.54 0 0 1 .397.16.54.54 0 0 1 .161.397.54.54 0 0 1-.161.397L6.648 11.75a.61.61 0 0 1-.47.19Z",
      class: "change-color-fill"
    }, null, -1)
  ]))]))
}
export default { render: render }